import { tns } from 'tiny-slider/src/tiny-slider';

class MediaContentSlider {
	constructor(el) {
		this.el = el;

		const wrap = this.el.closest('.block-media-content__slider-wrapper');
		if (!wrap) return;

		const prevButton = wrap.querySelector('.custom-prev-button');
		const nextButton = wrap.querySelector('.custom-next-button');
		const nav = wrap.querySelector('.custom-nav-container-media-content');

		const hasControls = !!(prevButton && nextButton);
		const hasNav = !!nav;

		const mediaContentSlider = tns({
			container: this.el,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: hasControls,
			prevButton: prevButton || undefined,
			nextButton: nextButton || undefined,
			nav: hasNav,
			navPosition: 'bottom',
			navContainer: nav || undefined,
			gutter: 40,
			autoHeight: true
		});

		return mediaContentSlider;
		
	}
}

export default MediaContentSlider;